import * as React from "react";
import { TextInput } from "soprasteria-ui-library";

interface IProps {
    address: string;
    zipCode: string;
    city: string;
    phoneNumber?: string;
    alternativePhoneNumber?: string;
    emailAddress?: string;
    showEmailAddress?: boolean;
}

export const PostalAddressInformation: React.FunctionComponent<IProps> = ({ address, zipCode, city, phoneNumber, alternativePhoneNumber, emailAddress, showEmailAddress = true }) => {

    return (
        <>
            <div className="col-6">
                <TextInput label="Postadress" name="readonly" defaultValue={address} readonly inlineLabel />
                <TextInput label="Postnummer" name="readonly" defaultValue={zipCode} readonly inlineLabel />
                <TextInput label="Postort" name="readonly" defaultValue={city} readonly inlineLabel />
            </div>
            <div className="col-6">
                {
                    showEmailAddress && <TextInput label="E-postadress" name="readonly" defaultValue={emailAddress ?? "-"} readonly inlineLabel />
                }
                <TextInput label="Telefonnummer" name="readonly" defaultValue={phoneNumber ?? "-"} readonly inlineLabel />
                <TextInput label="Alt. telefonnummer" name="readonly" defaultValue={alternativePhoneNumber ?? "-"} readonly inlineLabel />
            </div>
        </>
    )
}